export default {
  isEmail: 'This is not a valid email',
  minLength: 'This field is not valid',
  minLengthHelp: (val: number): string => `Enter at least ${val} characters`,
  equalsField: "The value doesn't match confirmation",
  required: 'This field is required',
  isEmptyArray: 'This field is required',
  positiveNumber: 'This field is not a positive number',
  positiveNumberRegexp: /^[+]?([0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/,
};
